<template>
  <div ref='modal' aria-hidden="true" class="modal fade hidden always-on-top" role="dialog" tabindex='-1'>
    <div class="modal-dialog">
      <div class="modal-content">

        <div v-if='hasHeader' class="modal-header">
          <slot name='header'></slot>
            <button v-if="!$props.noClose" aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true">×</span>
            </button>
        </div>

        <slot name='body'></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      noClose:{
        type: Boolean,
        required: false,
        default: false
      }
    },
    computed: {
      hasHeader() {
        return !!this.$slots.header
      },
      hasCloseButton() {
        return ((this.$slots.noCloseButton) ? true : false)
      }
    },
    methods: {
      open() {
        $(this.$refs.modal).modal('show')
      },
      close() {
        $(this.$refs.modal).modal('hide')
      }
    },
  }
</script>
